(function() {
    'use strict';
    var AddressHistoryCtrl = function($scope, $compile, $uibModalInstance, ajaxCall, passedModel) {

        console.log("Inside AddressHistoryCtrl");

        $scope.ngModel             = passedModel;
        $scope.currentAddressModel = {};

        var xmsId   = passedModel.xmsId;
        var xmsType = passedModel.xmsType;
        var readOnlyfields = passedModel.readOnlyfields;
        var minYears = passedModel.minYears;
        var renameTitle = passedModel.renameTitle;

        $scope.addressModel = {
            addresses       : [],
            errorMessageVal : '',
            errorMessage    : false,
            disableBtn      : false,
            xmsType         : xmsType,
            xmsId           : xmsId,
            readOnlyfields  : readOnlyfields,
            renameTitle : renameTitle
        };

        $scope.ajaxCallMethod = function(ajaxUrl, data) {
            var errorMsg = 'Error';
            ajaxCall.getData(ajaxUrl, data).then(function(result) {
                $scope.addressModel.disableBtn = false;
                $scope.addressModel.successMsg = result.data.successMsg;
                $scope.ngModel.address = $scope.currentAddressModel;
                $scope.addressModel.xmsType = xmsType;
                $scope.addressModel.xmsId = xmsId;
                $scope.ngModel.address.xmsType = xmsType;
                $scope.ngModel.address.xmsId = xmsId;
                $scope.ngModel.address.minYears = minYears;
                $scope.ngModel.address.currentYears = numberOfYearsCovered();
                $scope.ngModel.address.readOnlyfields = readOnlyfields;

                $scope.closePop();
            }, function(result) {
                $scope.addressModel.disableBtn = false;
                $scope.addressModel.errorMessage = true;
                $scope.addressModel.errorMessageVal = errorMsg;
                $scope.addressModel.xmsType = xmsType;
                $scope.addressModel.xmsId = xmsId;
                $scope.ngModel.address.minYears = minYears;
                $scope.ngModel.address.readOnlyfields = readOnlyfields;
            });
        }

        $scope.saveAddressHistoryNg = function($event) {

            $scope.addressModel.errorMessage = false;

            var isValid = this.addressHistoryForm.$valid;

            if (isValid) {
                $event.preventDefault();

                var isNumYearsFulfilled = true;
                var hasGaps = false;

                if (typeof(minYears) != "undefined"){
                    isNumYearsFulfilled = isNumberOfYearsFulfilled(minYears);
                    if(minYears > 0) {
                        hasGaps = gapsInDate();
                    }
                }
                var isValidDates = isDateOverlapped();
                var isUntilPresentChecked = isAtleastOneUntilPresentChecked();

                if (isValidDates && isUntilPresentChecked && isNumYearsFulfilled && !hasGaps) {
                    $scope.addressModel.disableBtn = true;
                    var data = $scope.addressModel;
                    var ajaxUrl = WEBAPP_PATH + "/locator/saveAddressHistory";
                    $scope.ajaxCallMethod(ajaxUrl, data);
                } else {
                    $scope.addressModel.errorMessage = true;
                    $('.modal').animate({ scrollTop: 0 }, 'slow');
                    if (!isValidDates) {
                        $scope.addressModel.errorMessageVal = 'Dates are overlapped. Please adjust.';
                    }
                    if (!isUntilPresentChecked) {
                        $scope.addressModel.errorMessageVal = 'At least one address should be a current address - please ensure "Until Present" is selected on the current address.';
                    }
                    if(!isNumYearsFulfilled){
                        $scope.addressModel.errorMessageVal = 'Address history must cover '+minYears+' years';
                    }
                    if(hasGaps){
                        $scope.addressModel.errorMessageVal = 'Gaps in Dates. Please adjust';
                    }
                }
            }

        }

        $scope.removeAddress = function(index) {
            $scope.addressModel.addresses.splice(index, 1);
        }

        $scope.closePop = function($event) {
            if(angular.isDefined($scope.ngModel.address)) {
                $uibModalInstance.close($scope.ngModel.address);
            } else {
                $uibModalInstance.close(passedModel);
            }
        }

        $scope.cancel = function() {
            $scope.closePop();
        };

        $scope.addAddress = function() {
            $scope.addressModel.addresses.push({ 'label': 'Other Address' });
        }

        $scope.checkIfPresent = function(address) {
            if($scope.addressModel.addresses.length == 1)
                return true;
            else
                return address.untilPresent;
        }

        $scope.processDate = function(address, index) {

            if (address.untilPresent == true) {
                address.disableDate = true;
                address.label = 'Current Address';
            } else {
                address.disableDate = false;
                address.label = 'Other Address';
            }

            for (var i = 0; i < $scope.addressModel.addresses.length; i++) {
                var eachAddress = $scope.addressModel.addresses[i];
                if (i != index && eachAddress.untilPresent == true) {
                    eachAddress.untilPresent = false;
                    eachAddress.disableDate = false;
                    address.label = 'Other Address';
                }
            }
        }

        function isAtleastOneUntilPresentChecked() {
            var isUntilPresentChecked = false
            for (var i = 0; i < $scope.addressModel.addresses.length; i++) {
                var eachAddress = $scope.addressModel.addresses[i];
                if (eachAddress.untilPresent == true) {
                    isUntilPresentChecked = true;
                    $scope.currentAddressModel = eachAddress;
                    break;
                }
            }
            return isUntilPresentChecked;
        }

        function getToDate(address){
            if (address.untilPresent == true)
                return new Date()
            return address.to
        }

        function numberOfYearsCovered(){
            var minimumDate = $scope.addressModel.addresses[0].from
            var maximumDate = getToDate($scope.addressModel.addresses[0])
            for (var i = 1; i < $scope.addressModel.addresses.length; i++) {
                var eachAddress = $scope.addressModel.addresses[i];
                minimumDate = (minimumDate < eachAddress.from)?minimumDate:eachAddress.from
                var addressToDate = getToDate(eachAddress)
                maximumDate = (maximumDate > addressToDate)?maximumDate:addressToDate
            }
            var differenceInYears = maximumDate.getUTCFullYear() - minimumDate.getUTCFullYear()
            differenceInYears--
            var minDay   = minimumDate.getUTCDate()
            var maxDay   = maximumDate.getUTCDate()
            var minMonth = minimumDate.getUTCMonth()
            var maxMonth = maximumDate.getUTCMonth()

            if((maxMonth > minMonth)||(maxMonth==minMonth&&maxDay>=minDay)){
                differenceInYears++;
            }
            return differenceInYears;
        }

        function isNumberOfYearsFulfilled(noOfYears) {
            var isNumberOfYearsFulfilled = false
            if (numberOfYearsCovered() >= noOfYears) {
                isNumberOfYearsFulfilled = true;
            }
            return isNumberOfYearsFulfilled;
        }

        function isDateOverlapped() {
            var addresses = $scope.addressModel.addresses;
            var newArray = addresses.slice();

            newArray = newArray.sort(compareDates);
            var arrayLength = newArray.length;
            for (var i = 0; i < arrayLength - 1; i++) {
                if (newArray[i].to > newArray[i + 1].from) {
                    console.log("overlapped");
                    return false;
                }
            }
            return true;
        }

        function gapsInDate() {
            var addresses = $scope.addressModel.addresses;
            var newArray = addresses.slice();

            newArray = newArray.sort(compareDates);
            var arrayLength = newArray.length;
            var dayMillis = (1000 * 3600 * 24);
            for (var i = 0; i < arrayLength - 1; i++) {
                var differenceInDates = Math.abs(new Date(newArray[i].to).getTime() - new Date(newArray[i + 1].from).getTime());
                if (Math.ceil(differenceInDates /dayMillis) > 1) {
                    return true;
                }
            }
            return false;
        }

        function compareDates(a, b) {
            if (a.from < b.from)
                return -1;
            if (a.from > b.from)
                return 1;
            return 0;
        }
    }
    AddressHistoryCtrl.$inject = ['$scope', '$compile', '$uibModalInstance', 'ajaxCall', 'params'];
    angular.module('app').controller('AddressHistoryCtrl', AddressHistoryCtrl);
}());
